import { Limit } from './Limit';

export interface SpecLine {
  id: string;
  label?: string;
  legacyIds: number[];
  v4SpecificationId: string;
  type: number;
  applicationDefinition: string;
  sizes: string[];
  makes: string[];
  axles: string[];
  series: string[];
  treads: string[];
  ntr: ActionDetails;
  age: ActionDetails;
  repair: ActionDetails;
  limits: Limit[];
  specCode: string;
  specDescription: string;
  specType: string;
  defaultSpec: boolean;
  michelinSpec: boolean;
  exceedMichelinSpec: boolean;
}

export interface ActionDetails {
  limit: number;
  action: string;
  disposition?: string;
  disposalCode?: string;
  application?: string;
  axle?: string;
  treads?: string[];
}

export enum SpecificationType {
  REPAIR_RETREAD = 10,
  REPAIR_ONLY = 20
}

export enum ActionType {
  REJECT = 'actionRejectText',
  DOWNGRADE = 'actionDowngradeText'
}

export enum DispositionType {
  RETURN = 'dispositionReturnText',
  SCRAP = 'dispositionScrapText'
}

export function enforceNumberField({ event }: { event: any }): void {
  if (
    !(event.keyCode >= 48 && event.keyCode <= 57) && //Numbers[0-9]
    !(event.keyCode >= 96 && event.keyCode <= 105) && //Numpad Numbers[0-9]
    event.keyCode !== 8 && //Backspace
    event.keyCode !== 9 && //Tab
    event.keyCode !== 37 && //left-arrow
    event.keyCode !== 39 //right-arrow
  ) {
    event.preventDefault();
  }
}

export function emptySpecificationLine(id: string, label?: string): SpecLine {
  return {
    id,
    label: label ? label : '',
    legacyIds: [],
    v4SpecificationId: '',
    type: SpecificationType.REPAIR_RETREAD,
    applicationDefinition: 'allText',
    sizes: ['allText'],
    makes: ['allText'],
    axles: ['allText'],
    series: ['allText'],
    treads: ['allText'],
    ntr: emptyActionDetails(),
    age: emptyActionDetails(),
    repair: emptyActionDetails(),
    limits: [emptyLimit(1)],
    specCode: '',
    specDescription: '',
    specType: '',
    defaultSpec: false,
    michelinSpec: false,
    exceedMichelinSpec: false
  };
}

function emptyActionDetails(): ActionDetails {
  return {
    limit: 0,
    action: '',
    disposition: '',
    disposalCode: '',
    application: '',
    axle: '',
    treads: []
  };
}

export function emptyLimit(sectionNumber: number): Limit {
  return {
    sectionNumber,
    totalRepairLimits: {
      totalRepairs: 0,
      nailRepairs: 0,
      rnailCrownRepairs: 0,
      rnailShoulder: {
        repairs: 0,
        shoulder: {
          count: 0,
          size: ''
        },
        crown: {
          count: 0,
          size: ''
        }
      },
      section: {
        repairs: 0,
        shoulder: {
          count: 0,
          size: ''
        },
        crown: {
          count: 0,
          size: ''
        },
        sidewall: {
          count: 0,
          size: ''
        }
      }
    },
    otherRepairLimits: {
      spot: 0,
      bead: 0,
      liner: 0,
      brake: 0
    }
  };
}
export function getActionType(actionType: string) {
  if (['Scarto', 'Rejet', 'Recusar', 'Отхвърляне', 'Rechazar', 'REJECT', 'Reject'].includes(actionType)) {
    return ActionType.REJECT;
  } else if (['Declassamento', 'Rétrograder', 'Degradar', 'Понижаване', 'DOWNGRADE', 'Downgrade'].includes(actionType)) {
    return ActionType.DOWNGRADE;
  }
  return actionType;
}

export function getDispositionType(dispositionType: string) {
  if (['Ritorno', 'Retour', 'Devolver', 'Назад', 'RETURN', 'Return', 'DevoluciÃ³n'].includes(dispositionType)) {
    return DispositionType.RETURN;
  } else if (['Scarto', 'SCRAP', 'SU - Sucateamento', 'Брак', 'Scrap', 'Rebut', 'SC - Desecho'].includes(dispositionType)) {
    return DispositionType.SCRAP;
  }
  return dispositionType;
}
